import { supabase } from "@/integrations/supabase/client";
import { TokenService } from "@/services/auth/TokenService";

/**
 * Toggles a genie's notification channel via HG Sync, which now owns
 * notification channel state (replaces the old agent_socials.enabled column).
 */
export class AgentSocialsService {
  static async toggleNotificationChannel(
    agentId: string,
    channelType: string,
    enabled: boolean,
    channelId?: string,
  ): Promise<void> {
    const token = await TokenService.getAccessToken();
    if (!token) throw new Error("Authentication required to update notification channels");

    const { error } = await supabase.functions.invoke("handle-agent", {
      body: {
        action: "toggle-notification-channel",
        agentId,
        channelId,
        channelType,
        enabled,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (error) throw error;
  }
}
